import { scrollToHash } from "../utils";
export const SelectCourse = {
  SelectHour: document.getElementById('SelectHour'),
  RecommendCourse: document.getElementById('RecommendCourse'),
  pcbuttons: document.querySelectorAll<HTMLElement>('[data-pc-state]'),
  mbbuttons: document.querySelectorAll<HTMLElement>('[data-mobile-state]'),
  hourbuttons: document.querySelectorAll<HTMLElement>('[data-hour]'),
  courses: document.querySelectorAll<HTMLElement>('[data-course]'),
  isMobile: window.innerWidth < 768,
  init() {
    if (this.SelectHour && this.RecommendCourse && this.pcbuttons.length && this.mbbuttons.length && this.hourbuttons.length && this.courses.length) {
      this.courses.forEach(c => {
        c.classList.add('hidden');
      });
      this.pcbuttons.forEach(btn => {
        btn.addEventListener('click', () => {
          this.selectpcbtn(btn);
        });
      });
      this.mbbuttons.forEach(btn => {
        btn.addEventListener('click', () => {
          this.selectmbbtn(btn);
        });
      });
      this.hourbuttons.forEach(btn => {
        btn.addEventListener('click', () => {
          this.selecthourbtn(btn);
        });
      });
    }
  },
  breakPoint(isMobile: boolean) {
    this.reset();
    this.isMobile = isMobile;
  },
  reset() {
    this.pcbuttons.forEach(btn => {
      btn.classList.remove('is-selected');
      btn.removeAttribute('disabled');
    });
    this.mbbuttons.forEach(btn => {
      btn.classList.remove('is-selected');
      btn.removeAttribute('disabled');
    });
    this.resetHour();
    this.resetCourse();
  },
  selectpcbtn(selected: HTMLElement) {
    const state = selected.getAttribute('data-pc-state') as string;
    this.resetHour();
    this.resetCourse();
    this.pcbuttons.forEach(btn => {
      if (selected === btn) {
        btn.classList.add('is-selected');
      } else {
        btn.classList.remove('is-selected');
      }
    });
    this.toggleHourbtns(state);
  },
  selectmbbtn(selected: HTMLElement) {
    const state = selected.getAttribute('data-mobile-state') as string;
    this.resetHour();
    this.resetCourse();
    this.mbbuttons.forEach(btn => {
      if (selected === btn) {
        btn.classList.add('is-selected');
      } else {
        btn.classList.remove('is-selected');
      }
    });
    this.toggleHourbtns(state);
  },
  selecthourbtn(selected: HTMLElement) {
    this.hourbuttons.forEach(btn => {
      if (btn === selected) {
        btn.classList.add('is-selected');
      } else {
        btn.classList.remove('is-selected');
      }
    });
    const currentState = this.isMobile ? document.querySelector('[data-mobile-state].is-selected')?.getAttribute('data-mobile-state') : document.querySelector('[data-pc-state].is-selected')?.getAttribute('data-pc-state');
    const currentHour = selected.getAttribute('data-hour');
    const compareArray = [currentState, currentHour];
    this.courses.forEach(course => {
      const courseArray = course.getAttribute('data-course')?.split(',');
      if (courseArray?.length) {
        const result = compareArray.every(item => courseArray.includes(item));
        if (result) {
          course.classList.remove('hidden');
        } else {
          course.classList.add('hidden');
        }
      }
    });
    this.RecommendCourse?.classList.remove('hidden');
    scrollToHash('#RecommendCourse', null);

  },
  toggleHourbtns(state: string) {
    this.hourbuttons.forEach(btn => {
      const btnStates = btn.getAttribute('data-remove-state')?.split(',');
      if (btnStates?.includes(state)) {
        btn.setAttribute('disabled', 'true');
      } else {
        btn.removeAttribute('disabled');
      }
    });
    this.SelectHour?.classList.remove('hidden');
    scrollToHash('#SelectHour', null);
  },
  resetHour() {
    this.SelectHour?.classList.add('hidden');
    this.hourbuttons.forEach(btn => {
      btn.classList.remove('is-selected');
      btn.removeAttribute('disabled');
    });
  },
  resetCourse() {
    this.RecommendCourse?.classList.add('hidden');
    this.courses.forEach(c => {
      c.classList.add('hidden');
    });
  }
}
